<script lang="ts">
  import { Github } from "lucide-svelte";

  import { analytics } from "$lib/analytics";

  export let scriptPath: string;
  export let noSpacing: boolean = false;

  $: url = scriptPath.startsWith("http")
    ? scriptPath
    : "https://github.com/modal-labs/modal-examples/blob/main/" + scriptPath;
</script>

<div class="float-right" class:spacing={!noSpacing}>
  <a
    on:click={() => {
      analytics.track("Example Link Clicked", {
        path: scriptPath,
      });
    }}
    class="btn btn-outlined bg-white/5"
    href={url}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Github size={16} class="mr-2.5 text-white opacity-80" />
    <span class="text-base text-white/80">View on GitHub</span>
  </a>
</div>

<style lang="postcss">
  .spacing {
    @apply py-1 pl-4 mt-10 mr-2 mb-6;
  }
</style>
